var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.uri)?_c('div',{staticClass:"hero__video hero__video--mood"},[_c('video-component',{attrs:{"uri":_vm.uri,"autoplay":"","muted":"","loop":"","playsinline":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }